<template>
  <!-- XOL-67 (B4), UX v3 section 5: the ONE shell of the RTA's confirm dialogs (Decline, Withdraw proposal here;
       Transition to Site, Close RTA and Complete RTA later): an el-dialog with the shared `xol-info-dialog` look and
       the InfoDialogHeader (icon, title, subtitle), 480px (92% on a phone), never closed by a click on the mask, and
       the footer Cancel (default, small) then the action (small, `loading` while it runs), space-between.

       Presentational: it asks, the parent acts. `confirm` is the action, `cancel` every other way out (the button, Esc,
       the X). A dialog that is cancelled gives focus back to what opened it (v3 section 9). `focusSelector`, if given,
       is where focus goes when it opens (the Decline reason); otherwise the header takes it. -->
  <el-dialog
    :visible="visible"
    :title="title"
    append-to-body
    :width="isMediumOrLess ? '92%' : width"
    top="8vh"
    custom-class="xol-info-dialog rta-dialog"
    :close-on-click-modal="false"
    @open="onOpen"
    @opened="onOpened"
    @close="onCloseEvent"
    @closed="onClosed">

    <info-dialog-header slot="title" ref="header" :icon="icon" :title="title" :subtitle="subtitle" :compact="isMediumOrLess" />

    <div class="rta-dialog__body" ref="body">
      <slot />
    </div>

    <div slot="footer" class="rta-dialog__footer" :class="{ 'is-narrow': isMediumOrLess }">
      <el-button size="small" :disabled="loading" @click="cancel">Cancel</el-button>
      <el-button size="small" class="rta-dialog__ok" :type="okType" :loading="loading" @click="$emit('confirm')">{{ okText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import InfoDialogHeader from '@/components/requests/InfoDialogHeader'

export default {
  name: 'rta-dialog',

  components: { InfoDialogHeader },

  props: {
    visible: { type: Boolean, default: false },
    // An icon class: 'fa-reply'.
    icon: { type: String, default: 'fa-info-circle' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: null },
    width: { type: String, default: '480px' },
    okText: { type: String, required: true },
    // The action's Element type: 'primary' | 'success' | 'warning' | 'danger'.
    okType: { type: String, default: 'primary' },
    loading: { type: Boolean, default: false },
    // A selector inside the body that takes focus when the dialog has opened.
    focusSelector: { type: String, default: null }
  },

  methods: {
    onOpen () {
      this.opener = typeof document !== 'undefined' ? document.activeElement : null
    },

    onOpened () {
      var target = this.focusSelector && this.$refs.body ? this.$refs.body.querySelector(this.focusSelector) : null

      if (target && typeof target.focus === 'function') {
        target.focus()
      } else if (this.$refs.header && typeof this.$refs.header.focus === 'function') {
        this.$refs.header.focus()
      }
    },

    // Element's own close (the X, Esc): a way out, never the action.
    onCloseEvent () {
      this.$emit('cancel')
    },

    cancel () {
      this.$emit('cancel')
    },

    // After the leave transition: focus goes back to what opened the dialog, if it is still there.
    onClosed () {
      var opener = this.opener

      this.opener = null
      this.$emit('closed')

      if (opener && typeof opener.focus === 'function' && typeof document !== 'undefined' && document.body.contains(opener) && !opener.disabled) {
        opener.focus()
      }
    }
  },

  created () {
    // Not reactive.
    this.opener = null
  }
}
</script>

<style scoped>
.rta-dialog__footer { display: flex; justify-content: space-between; align-items: center; }
.rta-dialog__footer.is-narrow { flex-direction: column-reverse; align-items: stretch; }
.rta-dialog__footer.is-narrow .el-button { width: 100%; margin: 4px 0 0; }
.rta-dialog__body >>> p { margin: 0 0 10px; }
</style>
